import React from 'react';

const PostContentRenderer = ({ content }) => {
  if (!content) return null;

  return (
    <div 
      className="prose prose-lg dark:prose-invert max-w-none text-foreground/90 prose-headings:text-foreground prose-a:text-primary hover:prose-a:underline prose-strong:text-foreground prose-blockquote:border-primary prose-blockquote:bg-muted/30 prose-code:bg-muted/50 prose-code:p-1 prose-code:rounded prose-code:text-sm prose-img:rounded-lg prose-img:shadow-md"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default PostContentRenderer;